import React from 'react';
import ReactDom from 'react-dom';
import Home from '~pages/Home';

const App = () => <Home />;

ReactDom.render(<App />, document.getElementById('app'));
